import React, { useEffect } from "react";
import SocialLinks from "../includes/social-links";
import { NavLink, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

export default function Footer_new({ logged}) {
  const settings = useSelector((state) => state.fetchSiteSettings.siteSettings);

  const location = useLocation();
      const location_path = location.pathname;
      const current_page = location_path.split('/')[1];
      const pages = ['', 'about', 'mission', 'partner', 'services', 'blog', 'blog-detail', 'category', 'faq', 'privacy-policy', 'terms-conditions', 'contact', 'login', 'signup', 'reset-password', 'forgot-password', 'property'];
      const d = new Date();
      let year = d.getFullYear();
  const data={
    social_links: [
            {
                id: 1,
                image: '/images/social-instagram.svg',
                link: settings?.site_instagram
            },
            {
                id: 2,
                link: settings?.site_facebook,
                image: '/images/social-facebook.svg'
            },
            {
                id: 3,
                link: settings?.site_discord,
                image: '/images/social-discord.svg'
            },
            {
                id: 4,
                link: settings?.site_twitter,
                image: '/images/social-twitter.svg'
            },
            {
                id: 4,
                image: '/images/social-email.svg',
                link: 'mailto:' + settings?.site_email
            },
        ]
  }
  return (
    <>
     {(pages.includes(current_page)) ?
      <footer>
        <div className="contain">
          <div className="flexRow flex">
            <div className="col">
              <ul className="lst">
                <li>
                  <NavLink to="/about">About Us</NavLink>
                </li>
                <li>
                  <NavLink to="/contact">Contact Us</NavLink>
                </li>
                <li>
                  <NavLink to="/blog">Blog</NavLink>
                </li>
                <li>
                  <NavLink to="/sitemap">Sitemap</NavLink>
                </li>
                <li>
                  <NavLink to="/faq">FAQs</NavLink>
                </li>
              </ul>
            </div>

            <div className="col">
              <h5>Follow us</h5>
              <SocialLinks data={data.social_links} />
            </div>
          </div>
        </div>

        <div className="copyright relative">
          <div className="contain">
            <div className="inner">
              <ul className="smLst flex">
                <li>
                  <NavLink to="/privacy-policy">Privacy Policy</NavLink>
                </li>
                <li>
                  <NavLink to="/terms-conditions">Terms & Conditions</NavLink>
                </li>
              </ul>
              <p>
                Copyright © {year} <a href="/">{settings?.site_name}</a>. {settings?.site_copyright}
              </p>
            </div>
          </div>
        </div>
      </footer>
         :
                ""
            }
    </>
  );
}
